<template>
  <ExtForm
    :formData="formData"
    :submitProxy="submitProxy"
    submitBtnText="Отправить анкету"
    submitBtnClasses="btn btn-success btn-block"
    @submitSuccess = "$emit('submitSuccess')"
    :showNotyfications="false"
    :extraData="{ type: 'entry' }"
    :emulateSubmit = "false"
  >
    <b-form-fieldset
      label="ФИО*"
      :feedback = "errors.first('fio')"
      :class="{'is-invalid': errors.has('fio') }"
      horizontal
    >
      <input class="form-control" v-validate="'required'" v-model.trim="formData.fio"  name="fio"/>
    </b-form-fieldset>
    <b-form-fieldset :feedback = "errors.first('birthdate')" label="Дата рождения*" :class="{'is-invalid': errors.has('birthdate') }" horizontal>
      <InlineDatepicker v-model="formData.birthdate" v-validate="'required|date'" name="birthdate"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Email*"
      :class="{'is-invalid': errors.has('email') }"
      :feedback = "errors.first('email')"
      horizontal
    >
      <input class="form-control" v-model.trim.lazy="formData.email" v-validate="'required|email'" name="email"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Контактный телефон*"
      :class="{'is-invalid': errors.has('tel') }"
      :feedback = "errors.first('tel')"
      horizontal
    >
      <input class="form-control" v-mask="'+7 (###) ###-##-##'" v-model="formData.tel" v-validate="'required'" name="tel"/>
    </b-form-fieldset>
    <b-form-fieldset label="Образование*" :feedback = "errors.first('education')" :class="{'is-invalid': errors.has('education') }" horizontal>
      <textarea class="form-control" v-validate="'required'" v-model.trim="formData.education" :rows="4" name="education"/>
      <small class="text-muted">Название  ВУЗа, факультета, специальности</small>
    </b-form-fieldset>
    <b-form-fieldset label="Год окончания ВУЗа*" :feedback = "errors.first('graduationYear')" :class="{'is-invalid': errors.has('graduationYear') }" horizontal>
      <input class="form-control" v-mask="'####'" v-validate="'required|numeric'" v-model.trim="formData.graduationYear" name="graduationYear"/>
    </b-form-fieldset>
    <b-form-fieldset label="Место  работы и должность*" :feedback = "errors.first('workAndPosition')" :class="{'is-invalid': errors.has('workAndPosition') }" horizontal>
      <input class="form-control" v-validate="'required'" v-model.trim="formData.workAndPosition" name="workAndPosition"/>
    </b-form-fieldset>
    <b-form-fieldset label="Стаж работы в сфере туризма" horizontal>
      <textarea class="form-control" rows="4" v-model.trim="formData.workExprience" />
      <small class="text-muted">Если есть,  укажите, в каких  фирмах работали</small>
    </b-form-fieldset>
    <b-form-fieldset label="С какой целью  поступаете на курсы?*" :feedback = "errors.first('goal')" :class="{'is-invalid': errors.has('goal') }" horizontal>
      <b-form-radio v-validate="'required'" :options="variants" stacked  v-model.trim="formData.goal" name="goal"/>
    </b-form-fieldset>
    <b-form-fieldset label="Из  каких  источников узнали о наших курсах?" :class="{'is-invalid': errors.has('sourceFrom') }" horizontal>
      <input class="form-control" v-model.trim="formData.sourceFrom" name="sourceFrom"/>
    </b-form-fieldset>
    <b-form-fieldset label="Какие темы по истории города для Вас наиболее интересны?"  horizontal>
      <input class="form-control" v-model.trim="formData.interestingTopics"/>
    </b-form-fieldset>
  </ExtForm>
</template>

<script>
import ExtForm from '@/components/ExtForm'
import Datepicker from '@/components/Datepicker'
import InlineDatepicker from '@/components/InlineDatepicker'

export default {
  data () {
    return {
      formData: {
        birthdate: '',
        fio: '',
        email: '',
        tel: '',
        education: '',
        graduationYear: '',
        workAndPosition: '',
        workExprience: '',
        goal: '',
        sourceFrom: '',
        interestingTopics: ''
      },
      submitProxy: {
        url: 'mail.php',
        method: 'post'
      },
      variants: [
        'Пополнить свои знания о городе',
        'Получить профессию  экскурсовода для совмещения с основной работой в период отпуска и выходные  дни',
        'Полностью поменять профессию, став экскурсоводом на постоянной основе'
      ]
    }
  },
  components: {
    ExtForm,
    Datepicker,
    InlineDatepicker
  }
}
</script>



// WEBPACK FOOTER //
// EntryLevelQuestionnaire.vue?22779a6c